require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-isabella-organ.json") })
        }
      }, "path---blog-author-isabella-organ");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-isabella-organ!./.cache/json/blog-author-isabella-organ.json
// module id = 640
// module chunks = 231608221292675